import { DroneEntity, DroneStatusType } from '@src/core/features';
import { isUpdateRequiredStatus } from '@src/features/drone/utils/operational-drones';

/** Ignore stale `missionId` on IDLE / update-required unless an active order ties the drone to a mission. */
export function trustedMissionIdFromDrone(drone: DroneEntity | null): string | undefined {
  if (!drone?.missionId) return undefined;
  if (
    drone.status !== DroneStatusType.IDLE &&
    !isUpdateRequiredStatus(drone.status)
  ) {
    return drone.missionId;
  }
  const orderId = drone.currentOrderId;
  if (orderId != null && Number(orderId) !== 0) return drone.missionId;
  return undefined;
}
